var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTymeplus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204.736,
    height: 93.922,
    viewBox: "0 0 204.736 93.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26300",
    "data-name": "Group 26300",
    transform: "translate(-214.398 -155.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4226",
    "data-name": "Group 4226",
    transform: "translate(214.398 155.274)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M91.583,143.355a49.4,49.4,0,0,1,49.4-49.4c11.276,0,23.263,5.224,31.577,11.583-9.006-8.864-22.957-15.777-36.592-15.777a49.9,49.9,0,0,0-23.506,93.922A49.332,49.332,0,0,1,91.583,143.355Z",
    transform: "translate(-86.064 -89.766)",
    fill: "#ee2738"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M191.5,114.171a44.7,44.7,0,0,0-62.54-.9,52.32,52.32,0,0,1,62.54.9Z",
    transform: "translate(-105.006 -94.708)",
    fill: "#262525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M104.687,170.341a38.123,38.123,0,0,0,21.263,48.93,44.626,44.626,0,0,1-21.263-48.93Z",
    transform: "translate(-93.174 -125.349)",
    fill: "#262525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M204.009,133.135l-30.342,30.671-2.171-2.312Z",
    transform: "translate(-123.791 -108.918)",
    fill: "#867970"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M147.114,158l16.942,13.419-2.146,2.335Z",
    transform: "translate(-113.024 -119.9)",
    fill: "#867970"
  })), /*#__PURE__*/React.createElement("text", {
    id: "TYMEPLUS",
    transform: "translate(268.135 231.99)",
    fill: "#867970",
    fontSize: 28,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "TYMEPLUS")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTymeplus);
export default __webpack_public_path__ + "static/media/tymeplus.9d9104a2335ec139c7ec704b3e181d95.svg";
export { ForwardRef as ReactComponent };